import styled, { css } from "styled-components";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { IconWrapper } from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import * as Pill from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Pill";

export const Slider = styled.div`
    flex: 1;
    overflow: hidden;
`;

export const SliderViewport = styled.div`
    position: relative;
    width: 100%;
    max-width: 100vw;
    height: ${60 + 2 * theme.space[3]}px;
    margin: 0 auto;
    padding: ${theme.space[3]}px ${theme.spacer / 2}px;
    overflow-y: hidden;

    &::after {
        display: block;
        position: fixed;
        top: 62px; /* Height FilterSidebarStyles__MobileHeader */
        left: 0;
    }

    @media ${getBreakpoint("up", "lg")} {
        height: auto;
        padding: 0;
    }

    html[dir="rtl"] & {
        &::after {
            left: 0;
            right: auto;
        }
    }
`;

type TrackType = { width?: number; left: number; enableTransition: boolean };
export const Track = styled.div.attrs<TrackType>((props) => ({
    style: { transform: `translateX(${props.left}px)` },
}))<TrackType>`
    display: flex;
    left: 0;
    flex-direction: row;
    width: ${(props) => props.width}px;
    ${(props) =>
        props.enableTransition &&
        css`
            transition: transform 0.5s;
        `};

    @media ${getBreakpoint("up", "lg")} {
        position: relative;
        flex-wrap: wrap;
        width: 100%;
    }

    html[dir="rtl"] & {
        left: auto;
        right: 0;
    }
`;

export const Prerender = styled.div`
    height: 0;
    opacity: 0;
`;

export const Wrapper = styled.div`
    padding: ${theme.space[1]}px ${theme.space[2]}px;
`;

export const PillWrapper = styled.div<{ isSelected?: boolean }>`
    display: inline-block;
    position: relative;
    padding: 0;
    padding-left: 0;
    padding-right: ${theme.space[1]}px;
    z-index: ${({ isSelected }) => (isSelected ? 1061 : "auto")};

    @media (max-width: 320px) {
        /* Fix, only for the smallest screens: OR-7406 */
        max-width: 288px; /* 320 - 32px (spacing) */
    }

    @media ${getBreakpoint("up", "lg")} {
        padding-bottom: ${theme.space[1]}px;
    }

    ${Pill.Wrapper} {
        column-gap: ${theme.space[1]}px;
        margin: 5px 0;
        border-color: ${({ isSelected }) => (isSelected ? theme.colors.midnight : theme.colors.platinumMedium)};

        ${IconWrapper} {
            display: flex;
            align-items: center;
        }
    }

    ${Pill.Text} {
        max-width: none;
        color: ${({ isSelected }) => (isSelected ? theme.colors.midnight : theme.colors.platinumDark)};
        background-color: transparent;
    }

    html[dir="rtl"] & {
        padding-left: ${theme.space[1]}px;
        padding-right: 0;
    }
`;

export const PillText = styled.span<{ strikethrough: boolean }>`
    ${({ strikethrough }) =>
        strikethrough &&
        css`
            text-decoration: line-through;
        `};
`;
